import React from 'react'
import { Outlet } from 'react-router-dom'
import HomeHeader from './HomeHeader'
import HomeFooter from './HomeFooter'

const HomeLayoute = () => {
    return (
        <>
            <HomeHeader />
            <Outlet />
            <HomeFooter />
        </>
    )
}

export default HomeLayoute